import React, { useRef, useEffect } from 'react';
import Button from '../../button';
import { BUTTON_TYPE } from '../../../global/constants';

interface ImproveModalContentProps {
  isImproveLoading: boolean;
  improvedText: string;
  onClickReplace: (e?: React.MouseEvent) => void;
  onDismiss: (e?: React.MouseEvent) => void;
}

const ImproveModalContent: React.FC<ImproveModalContentProps> = ({
  isImproveLoading,
  improvedText,
  onClickReplace,
  onDismiss
}) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const autoResize = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
    }
  };

  useEffect(() => {
    autoResize();
  }, [improvedText, isImproveLoading]);

  return (
    <>
      <textarea
        ref={textareaRef}
        placeholder='I would like to talk about it!'
        value={isImproveLoading ? 'Loading...' : improvedText || ''}
        readOnly
        onInput={autoResize}
      />
      <div className='button-div'>
        <Button
          title='Dismiss'
          variant={BUTTON_TYPE.TERTIARY}
          onClick={(e) => {
            e.stopPropagation();
            onDismiss(e);
          }}
          size='small'
          disabled={isImproveLoading}
        />
        <Button
          variant={BUTTON_TYPE.PRIMARY}
          onClick={(e) => {
            e.stopPropagation();
            onClickReplace(e);
          }}
          title='Replace'
          size='small'
          disabled={isImproveLoading}
        />
      </div>
    </>
  );
};

export default ImproveModalContent;
